module.exports = __webpack_public_path__ + "img/notification_info_icon.9c838e4c.svg";